/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import Toast from './sub_components/toast'
import Currency from './sub_components/currency'
import * as accountStatementService from '../services/accountStatementService'
import * as casinoReportsService from '../services/casinoReportsService'
import * as dateUtil from '../util/date.util'
import * as authUtil from "../util/auth.util";
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import * as _ from 'lodash'
class AccountStatement extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            user_id: '',
            types: "ALL",
            statements_data: [],
            orders: [],
            statements_search_data: [],
            csv_json: [],
            pdf_json: [],
            competition_id: "",
            event_id: "",
            market_id: "",
            last_id: "",
            first_id: "",
            action: "",
            from: "",
            to: "",
            page_no: 1,
            count_records: 0,
            records_per_page: 25,
            opening_balance: 0,
            closing_balance: 0,
            current_balance: 0,
            hst_balance: [],
            showToast: false,
            showPopup: false,
            showPopuploader: false,
            toastMsg: "",
            toastType: "",
            showData: false,
            loader: false,
            isMaintanance: false
        };
    }

    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            authUtil.logout(true);
        }
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ user_id: userData.sub, to: curDate, from: weekDate })
    }

    parseToPickerDate(date) {
        let dtArr = date.split("/")
        let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
        return dt
    }

    parseFilterBody() {
        // let body = {
        //     "filters": {
        //         "user_ids": this.state.user_id,
        //         "types": this.state.types
        //     },
        //     "last_id": this.state.last_id,
        //     "first_id": this.state.first_id,
        //     "action": this.state.action,
        //     "from": new Date(this.state.from).toISOString(),
        //     "to": new Date(this.state.to).toISOString(),
        //     "zone": new Date().getTimezoneOffset(),
        //     "page_no": this.state.page_no,
        //     "records_per_page": this.state.records_per_page,
        //     "count_records": this.state.count_records,
        //     "opening_balance": this.state.page_no !== 1 ? this.state.opening_balance : 0,
        //     "closing_balance": this.state.closing_balance,
        //     "current_balance": this.state.current_balance,
        //     "hst_balance": this.state.hst_balance
        // }

        let body = {
            "filters":{
                "types": this.state.types
            },
            "lastId": this.state.last_id,
            "firstId": this.state.first_id,
            "closingBalance": this.state.closing_balance,
            "hstBalance": this.state.hst_balance,
            "action": this.state.action,
            "from": new Date(this.state.from).toISOString(),
            "to": new Date(this.state.to).toISOString(),
            "countRecords": this.state.count_records,
            "pageNo": this.state.page_no,
            "recordsPerPage": this.state.records_per_page
        }
        body = this.clean(body);
        return body
    }
    async submitForm() {
        const self = this;
        let body = this.parseFilterBody()
        this.setState({ loader: true })
        await accountStatementService.postTransaction(body).then((res) => {
            if (res.isSuccess) {
                self.setState(
                    {
                        statements_data: [],
                        statements_search_data: [],
                        last_id: res.lastId,
                        first_id: res.firstId,
                        action: res.action,
                        page_no: res.pageNo,
                        records_per_page: res.recordsPerPage,
                        count_records: res.countRecords,
                        opening_balance: 0.00,
                        closing_balance: 0.00,
                        current_balance: res.currentBalance,
                        hst_balance: [],
                        showData: true,
                    }, () => {
                        let closing_bal = res.openingBalance;
                        for (let smt of res.items) {
                            if (smt.creditAccount === this.state.user_id) {
                                closing_bal += smt.amount
                            } else {
                                closing_bal -= smt.amount
                            }
                        };
                        self.setState({
                            statements_data: res.items,
                            statements_search_data: res.items,
                            opening_balance: res.openingBalance,
                            closing_balance: closing_bal,
                            hst_balance: res.hstBalance,
                            loader: false
                        })
                    }
                );
            } else {
                this.setState({ statements_data: [], statements_search_data: [], showData: true, loader: false, last_id: "", first_id: "", action: "", page_no: 1, hst_balance: [], count_records: 0, current_balance: 0, opening_balance: 0, closing_balance: 0 })
            }
        })
    }
    async onDownload() {
        const self = this;
        this.setState({ csv_json: [] }, () => {

            let trans = this.state.statements_search_data
            let dictinory = {}
            let balance = this.state.opening_balance
            let items = []
            let filter_user_id = this.state.user_id
            dictinory["Date"] = ""
            dictinory["Credit"] = ""
            dictinory["Debit"] = ""
            dictinory["Balance"] = Math.round((balance + Number.EPSILON) * 100) / 100
            dictinory["Description"] = "Opening Balance"
            items.push(dictinory)
            for (let x of trans) {
                dictinory = {}
                let st = x["createdAt"].split(" ")
                let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                let dt = new Date(dtstr).toLocaleString("en-IN")
                dictinory["Date"] = dt
                if (x["creditAccount"] === filter_user_id) {
                    dictinory["Credit"] = x["amount"]
                    dictinory["Debit"] = "-"
                    balance += Math.round((x["amount"] + Number.EPSILON) * 100) / 100
                }
                if (x["debitAccount"] === filter_user_id) {
                    dictinory["Credit"] = "-"
                    dictinory["Debit"] = x["amount"]
                    balance -= Math.round((x["amount"] + Number.EPSILON) * 100) / 100
                }
                dictinory["Balance"] = Math.round((balance + Number.EPSILON) * 100) / 100
                dictinory["Description"] = x["description"]

                items.push(dictinory)

            }
            this.setState({ csv_json: items }, () => {
                setTimeout(function () {
                    self.csvLink.current.link.click();
                }, 500)

            })
        })
    }
    async onPDFDownload() {
        this.setState({ pdf_json: [] }, () => {
            this.setState({ pdf_json: this.state.statements_search_data }, () => {
                setTimeout(function () {
                    printJS({
                        printable: 'printJS-div',
                        type: 'html',
                        targetStyles: ['*']
                    })
                }, 500)
            })
        })
    }
    async marketOrders() {
        const self = this;
        // let body = {
        //     "filters": {
        //         "amount_from": 0,
        //         "amount_to": 0,
        //         "event_type_category": "",
        //         "competition_id": "",
        //         "event_id": "",
        //         "market_id": this.state.market_id,
        //         "market_type": "",
        //         "betstatus": [""]
        //     },
        //     "user_id": this.state.user_id,
        //     "last_id": "",
        //     "first_id": "",
        //     "action": "",
        //     "from": "",
        //     "to": "",
        //     "records_per_page": 100,
        //     "page_no": 1,
        //     "count_records": 0
        // }

        let body = {
            "filters":{
                "betStatus": "",
                "eventTypeCategory": "",
                "marketId": this.state.market_id,
            },
            "firstId": "",
            "lastId": "",
            "action": "",
            "from": "",
            "to": "",
            "pageNo": 1,
            "recordsPerPage": 100,
            "countRecords": this.state.count_records,
        }

        body = this.clean(body);
        this.setState({ orders: [], showPopuploader: true })
        await casinoReportsService.postOrders(body).then((res) => {
            if (res.isSuccess) {
                let orders = res.items.filter( (bet) => {return bet.eventTypeId !== "99" || (bet.eventTypeId === "99" && bet.betStatus !== "VOID")})
                self.setState(
                    {
                        orders: orders,
                        competition_id: "",
                        event_id: "",
                        market_id: "",
                        showPopuploader: false
                    }
                );
            }
            else {
                this.setState({ orders: [], showPopuploader: false })
            }
        })
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    hidePopup() {
        this.setState({ showPopup: false, orders: [] })
    }

    showPopup(type, id) {
        const name = type;
        let value = id;
        this.setState({ [name]: value, showPopup: true }, () => { this.marketOrders() })
    }
    onAction(e) {
        const value = e.target.name;
        let page_n = 1;
        if (value === "next") {
            page_n = this.state.page_no + 1;
        }
        if (value === "prev") {
            page_n = this.state.page_no - 1;
        }
        this.setState({ action: value, page_no: page_n }, () => { this.submitForm(); });
    }
    resetForm() {
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ types: "ALL", showData: false, records_per_page: 25, from: weekDate, to: curDate, statements_data: [], statements_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, hst_balance: [], current_balance: 0, opening_balance: 0, closing_balance: 0 })
    }
    onSubmit(e) {
        let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 31) {
            this.props.notify("Date range must be 1 month.", "error")
        }
        else {
            this.setState({ action: "", page_no: 1, hst_balance: [], current_balance: 0 }, () => { this.submitForm(); });
        }
    }
    onChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        if (name === "records_per_page" || name === "records_display") {
            this.setState({ [name]: value, hst_balance: [], opening_balance: 0, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 }, () => { this.submitForm() });
        }
        else {
            this.setState({ [name]: value });
        }
    }
    setMarketForm(type, id) {
        let body = {
            type: type,
            id: id
        }
        localStorage.setItem("casinoReportFilter", JSON.stringify(body))
        this.props.history.push("/orders");
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }
    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
    onSearch(e) {
        const value = e.target.value;
        if (this.state.statements_search_data) {
            let statements_lst = _.filter(this.state.statements_search_data, function (obj) {
                return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            this.setState({ statements_data: [] }, () => {
                this.setState({ statements_data: statements_lst });
            })

        }
    }
    render() {
        let page_no = parseInt(this.state.page_no)
        let count_records = parseInt(this.state.count_records)
        let records_per_page = parseInt(this.state.records_per_page)
        let current_record = 0
        let total_record = 0
        let start_record = 0
        if (count_records > (records_per_page * page_no)) {
            current_record = records_per_page * page_no
            total_record = count_records
            start_record = current_record - (records_per_page - 1)
        } else if (this.state.statements_data.length > 0) {
            current_record = count_records
            total_record = count_records
            start_record = ((page_no - 1) * records_per_page) + 1
        }
        let open_bal = this.state.opening_balance
        let pdf_open_bal = this.state.hst_balance[0]
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id)=>{this.props.subscribe(type, id)}} subscriptions={this.props.subscriptions} history = {this.props.history} socket={this.props.socket} updateMaintanence={(status)=>{this.updateMaintanence(status)}}/>
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Account Statement</p>
                            </div>

                            <div className="allreport col3">
                                <div className="row mx-0">
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mt-2">
                                        <div className="form-group font-12">
                                            <select onChange={(e) => { this.onChange(e) }} title="Transaction Types" className="form-control" name="types" value={this.state.types}>
                                                <option value="ALL">ALL</option>
                                                <option value="BALANCE">BALANCE REPORT</option>
                                                <option value="GAME">GAME REPORT</option>
                                                {/* <option value="SETTLEMENT">SETTLEMENT REPORT</option> */}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.from}
                                                onChange={(e) => this.onDateTimeChange("from", e)}
                                                id="from_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.to}
                                                onChange={(e) => this.onDateTimeChange("to", e)}
                                                id="to_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2 mb-3 mt-2">
                                        <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                            <button className="btn place-bet-btn" onClick={(e) => this.onSubmit(e)}>Go</button>
                                            <button className="btn place-bet-btn ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 mt-2">
                                        <table className="table table-bordered nowrap table-sm mb-1">
                                            <tbody>
                                                <tr className="w-100">
                                                    <td><span className="d-inline font-14">Opening Balance </span></td>
                                                    <td className="text-right">{this.state.opening_balance ? <Currency classPropName={"d-inline font-14"} amount={this.state.opening_balance} showColor={false} /> : "0.00"}</td>
                                                </tr>
                                                <tr className="w-100">
                                                    <td><span className="d-inline font-14">Closing Balance &nbsp;&nbsp; </span></td>
                                                    <td className="text-right">{this.state.closing_balance ? <Currency classPropName={"d-inline font-14"} amount={this.state.closing_balance} showColor={false} /> : "0.00"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {!this.state.showData && !!this.state.loader ? <div className={"ml-2"}>Loading......</div> : null}
                                {!!this.state.showData && <div>
                                    <div className="row text-center mt-2 mx-0 px-1">

                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 mt-1 px-2">
                                            <div className="d-flex float-left">
                                                <div className="form-group mb-0 d-inline">
                                                    <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                                </div>
                                                <CSVLink
                                                    data={this.state.csv_json}
                                                    filename={"Account-Ledger-Report.csv"}
                                                    asyncOnClick={true}
                                                    className="d-none"
                                                    ref={this.csvLink}>
                                                </CSVLink>
                                                <button className="btn btn-sm d-inline csv-icon p-0" title="Export CSV" onClick={(e) => this.onDownload(e)} disabled={this.state.statements_data.length > 0 ? false : true}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/csv-icon.svg"}></img></button>
                                                <div style={{ display: "none" }}>
                                                    <div id="printJS-div">
                                                        <table id="exportall" className="table font-12 table-bordered table-sm" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px' }}>
                                                            <thead>
                                                                <tr className="bg-dark text-white">
                                                                    <th className="wid200 pthead text-left">Date</th>
                                                                    <th className="wid140 text-right pthead">Credit</th>
                                                                    <th className="wid140 text-right pthead">Debit</th>
                                                                    <th className="wid140 text-right pthead">Balance</th>
                                                                    <th className=" text-left pthead">Description</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr bgcolor="#FFFFFF">
                                                                    <td></td>
                                                                    <td className="text-right text-success"></td>
                                                                    <td className="text-right text-danger"></td>
                                                                    <td className="text-right fbold">{this.state.opening_balance ? <Currency classPropName={this.state.opening_balance > 0 ? "text-success fbold" : this.state.opening_balance < 0 ? "text-danger fbold" : "fbold"} amount={this.state.opening_balance} showColor={false} /> : "0.00"}</td>
                                                                    <td className="text-left">Opening Balance</td>
                                                                </tr>
                                                                {this.state.pdf_json.length > 0 ? this.state.pdf_json.map((user, i) => {
                                                                    let st = (user.createdAt).split(" ")
                                                                    let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                                    let dt = new Date(dtstr).toLocaleString("en-IN")
                                                                    if (user.creditAccount === this.state.user_id) {
                                                                        pdf_open_bal += user.amount
                                                                    } else {
                                                                        pdf_open_bal -= user.amount
                                                                    }
                                                                    return (
                                                                        <tr key={i} bgcolor="#FFFFFF">
                                                                            <td className="text-left">{dt}</td>
                                                                            <td className="text-right fbold">{user.creditAccount === this.state.user_id ? <Currency classPropName={"text-success fbold"} amount={user.amount} showColor={false} /> : "-"}</td>
                                                                            <td className="text-right fbold">{user.debitAccount === this.state.user_id ? <Currency classPropName={"text-danger fbold"} amount={user.amount} showColor={false} /> : "-"}</td>
                                                                            <td className="text-right text-dark fbold">{pdf_open_bal ? <Currency classPropName={pdf_open_bal > 0 ? "text-right text-success fbold" : pdf_open_bal < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={pdf_open_bal} showColor={false} /> : "0.00"}</td>
                                                                            <td className="text-left">{!!user.description ? user.description : "-"}</td>
                                                                        </tr>
                                                                    );
                                                                }) : <tr style={{ display: "block" }}>
                                                                    <td colSpan={15} className="text-center"><h5 className="text-danger font-weight-bold m-0">No Statements</h5></td>
                                                                </tr>}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <button className="btn btn-sm pdf-icon d-inline p-0" title="Export PDF" onClick={(e) => this.onPDFDownload(e)} disabled={this.state.statements_data.length > 0 ? false : true}>
                                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/pdf-icon.svg"}></img>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <span className="d-inline search-report ml-2">entries</span>
                                            <div className="form-group font-12 float-right mb-0">
                                                <select onChange={(e) => { this.onChange(e) }} className="form-control" name="records_per_page" value={this.state.records_per_page}>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>
                                            <span className="d-inline search-report">Show</span>
                                        </div>
                                    </div>
                                    <div className="dt-responsive table-responsive account-statment p-2">
                                        <table id="basic-btn" className="table table-bordered nowrap table-sm mb-1 addpadding">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th className="wid140 pthead">Date</th>
                                                    <th className="wid140 text-right pthead">Credit</th>
                                                    <th className="wid140 text-right pthead">Debit</th>
                                                    <th className="wid140 text-right pthead">Balance</th>
                                                    <th className="pthead">Description</th>
                                                </tr>
                                            </thead>
                                            <tbody id="tblAccountStatement">
                                                <tr>
                                                    <td></td>
                                                    <td className="text-right text-success"></td>
                                                    <td className="text-right text-danger"></td>
                                                    <td className="text-right fbold">{this.state.opening_balance ? <Currency classPropName={this.state.opening_balance > 0 ? "text-success fbold" : this.state.opening_balance < 0 ? "text-danger fbold" : "fbold"} amount={this.state.opening_balance} showColor={false} /> : "0.00"}</td>
                                                    <td> Opening Balance </td>
                                                </tr>
                                                {!!this.state.loader ?
                                                    <tr>
                                                        <td colSpan={17} className="text-center py-5">
                                                            <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                        </td>
                                                    </tr> :
                                                    this.state.statements_data.length > 0 ? this.state.statements_data.map((user, i) => {
                                                        let st = (user.createdAt).split(" ")
                                                        let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                        let dt = new Date(dtstr).toLocaleString("en-IN")
                                                        if (user.creditAccount === this.state.user_id) {
                                                            open_bal += user.amount
                                                        } else {
                                                            open_bal -= user.amount
                                                        }
                                                        let description = !!user.tags && user.tags.length === 0 ? "-" : user.tags[0] === "BINARY" ? dateUtil.getBinaryDescriptionDisplay(user.description) : user.description
                                                        //getBinaryDescriptionDisplay
                                                        return (
                                                            <tr key={i}>
                                                                <td className="text-left" title={dt}>{dt}</td>
                                                                <td className="text-right">{user.creditAccount === this.state.user_id ? <Currency classPropName={"text-success fbold"} amount={user.amount} showColor={false} /> : "-"}</td>
                                                                <td className="text-right">{user.debitAccount === this.state.user_id ? <Currency classPropName={"text-danger fbold"} amount={user.amount} showColor={false} /> : "-"}</td>
                                                                <td className="text-right text-dark fbold">{!!open_bal ? <Currency classPropName={open_bal > 0 ? "text-right text-success fbold" : open_bal < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={open_bal} showColor={false} /> : "0.00"}</td>
                                                                <td className="" title={user.description}>
                                                                    {user.tags === null ? "-" : user.tags.length > 2 ?
                                                                        <a className="undline" onClick={(e) => this.showPopup("market_id", user.tags[1])} name="event_id">{
                                                                            user.tags[0] === "BINARY" ?
                                                                            <>
                                                                                {description[0]}/{description[1][0]}
                                                                                <span>[Time: <b>{(description[1][1])}</b>]</span>
                                                                                /{description[2]}
                                                                            </>
                                                                             : description
                                                                        }</a> :
                                                                        user.tags[0] === "BINARY" ?
                                                                            <>
                                                                                {description[0]}/{description[1][0]}
                                                                                <span> [Time: <b>{(description[1][1])}</b>]</span>
                                                                                /{description[2]}
                                                                            </>
                                                                             : description
                                                                             }
                                                                </td>
                                                            </tr>
                                                        );
                                                    }) : <tr>
                                                        <td colSpan={15} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Statements</h5></td>
                                                    </tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row mx-0 px-1 py-3">
                                        <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                                        <div className="col-12 col-sm-12 col-md-6">
                                            <div className="btn-group float-right" role="group" aria-label="Basic example" id="divpagecount">
                                                <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" ? true : false}>Prev</button>
                                                <button className="btn btn-blue" disabled>
                                                    {
                                                        this.state.page_no
                                                    }
                                                </button>
                                                <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" ? true : false}>Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {this.state.showPopup && <>
                        <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">User Market Bets</h5><button onClick={() => { this.hidePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="table-responsive">
                                            <table id="basic-btn" className="table  table-bordered font-12 table-sm">
                                                <thead>
                                                    <tr className="bg-dark text-white">
                                                        <th className="wid150 pthead">Competition</th>
                                                        <th className="wid280 pthead">Event</th>
                                                        <th className="wid150 pthead">Market</th>
                                                        <th className="wid140 pthead">Runner</th>
                                                        <th className="wid100 pthead">Side</th>
                                                        <th className="wid100 text-right pthead">Line</th>
                                                        <th className="wid100 text-right pthead">Rate</th>
                                                        <th className="wid100 text-right pthead">Amount</th>
                                                        <th className="wid100 text-right pthead">Profit/Loss</th>
                                                        <th className="wid140 pthead">Status</th>
                                                        <th className="wid165 pthead">Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!this.state.showPopuploader ?
                                                        <tr>
                                                            <td colSpan={17} className="text-center py-5">
                                                                <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                            </td>
                                                        </tr> :
                                                        this.state.orders.length > 0 ? this.state.orders.map((ordr, i) => {
                                                        let order = ordr
                                                        if(order.eventTypeId === '300'){
                                                            order.marketTime =  dateUtil.getBinaryMarketDisplayName(order.marketName)
                                                        }
                                                            if(order.eventTypeId === "99" && order.betStatus === "VOID"){
                                                                return null
                                                            }

                                                            let st = (order.createdAt).split(" ")
                                                            let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                            let dt = new Date(dtstr).toLocaleString("en-IN")
                                                            let price = order.price
                                                            let competitionName = order.competitionName ? (order.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(order.competitionName) : order.competitionName) : "-"
                                                            return (
                                                                <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                                    <td>{competitionName}</td>
                                                                    <td>{order.eventName ? order.eventName : "-"}</td>
                                                                    <td>{order.eventTypeId === '300' && !!order.marketTime && order.marketTime.length > 0 ? 
                                                            <>
                                                            {order.marketTime[0] }
                                                            <span className=''> [<b>{(order.marketTime.length > 0 ? order.marketTime[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!order.marketName ? order.marketName : "-"}</td>
                                                                    <td>{order.runnerName ? order.runnerName : "-"}</td>
                                                                    <td>{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                                    <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                                    <td className="text-right fbold">{price ? price : "-"}</td>
                                                                    <td className="text-right"><Currency classPropName={"fbold"} amount={order.amount ? order.amount : "0"} showColor={false} /></td>
                                                                    {order.eventTypeId !== "99" ?
                                                                        <td className="text-right"><Currency classPropName={order.betStatus === "WON" ? "text-success fbold" : order.betStatus === "LOST" ? "text-danger fbold" : "fbold"} amount={order.betStatus === "WON" ? order.potentialProfit : order.betStatus === "LOST" ? order.potentialLoss : "0"} showColor={false} /></td>
                                                                        : <td className="text-right">-</td>
                                                                    }
                                                                    <td>{!!order.betStatus ? order.betStatus : "-"}</td>
                                                                    <td>{dt ? dt : "-"}</td>
                                                                </tr>
                                                            );
                                                        }) : <tr>
                                                            <td colSpan={17} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Bet History</h5></td>
                                                        </tr>}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" onClick={() => { this.hidePopup() }} className="btn btn-outline-danger waves-effect mx-auto" data-dismiss="modal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-backdrop fade show" onClick={() => { this.hidePopup() }}></div>
                        </div>

                    </>}
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AccountStatement);